(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ss-product-gallery')) {
    customElements.define('ss-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const slides = this.querySelector('.ss-product-gallery__slides');
        const links = [...this.querySelectorAll('.ss-product-gallery__thumbnails a')];
        this.addEventListener('click', (event) => {
          const link = event.target.closest('.ss-product-gallery__thumbnails a');
          if (!link) return;
          const target = this.querySelector(link.hash);
          if (!target) return;
          event.preventDefault();
          slides.scrollTo({ left: target.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal: this.controller.signal });
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              links.forEach((link) => {
                if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
              });
            } else { entry.target.querySelectorAll('video').forEach((video) => video.pause()); }
          });
        }, { root: slides, threshold: .6 });
        slides.querySelectorAll('.ss-product-gallery__slide').forEach((slide) => this.observer.observe(slide));
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-option-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-option-picker')) {
    window.addEventListener('pageshow', (event) => {
      if (event.persisted && document.querySelector('product-option-picker[data-navigating]')) window.location.reload();
    });

    customElements.define('product-option-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.onOptionChange) return;

        try {
          const saved = JSON.parse(sessionStorage.getItem('ss-option-focus') || 'null');
          if (saved && saved.path === window.location.pathname && Date.now() - saved.time < 30000) {
            sessionStorage.removeItem('ss-option-focus');
            const selected = this.querySelector(`[data-option-position="${saved.position}"]:checked`);
            if (selected && !selected.disabled) {
              requestAnimationFrame(() => {
                selected.focus({ preventScroll: true });
                window.scrollTo(0, saved.scroll);
              });
            }
          }
        } catch { /* Selection remains usable when browser storage is unavailable. */ }

        this.onOptionChange = (event) => {
          const input = event.target;
          if (!input.matches('.product-options__input') || input.disabled) return;

          const destination = new URL(input.dataset.productUrl || this.dataset.productUrl, window.location.origin);
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.forEach((value, key) => {
            if (!['variant', 'option_values', 'section_id'].includes(key)) destination.searchParams.set(key, value);
          });
          destination.searchParams.set('option_values', [...this.querySelectorAll('input:checked')].map((value) => value.value).join(','));

          try {
            sessionStorage.setItem('ss-option-focus', JSON.stringify({
              path: destination.pathname,
              position: input.dataset.optionPosition,
              scroll: window.scrollY,
              time: Date.now(),
            }));
          } catch { /* Browser storage is optional. */ }

          this.setAttribute('data-navigating', '');
          this.setAttribute('aria-busy', 'true');

          const form = this.closest('form');
          if (form) {
            form.querySelectorAll('[name="id"], [type="submit"]').forEach((control) => { control.disabled = true; });
            const payment = form.querySelector('.shopify-payment-button');
            if (payment) payment.hidden = true;
          }

          window.location.assign(destination.href);
        };

        this.addEventListener('change', this.onOptionChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onOptionChange);
        this.onOptionChange = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ss-quantity')) {
    customElements.define('ss-quantity', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.input = this.querySelector('input');
        const sync = () => {
          const value = Number(this.input.value);
          this.querySelector('[data-step="-1"]').disabled = value <= Number(this.input.min);
          this.querySelector('[data-step="1"]').disabled = this.input.max !== '' && value >= Number(this.input.max);
        };
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-step]');
          if (!button || button.disabled) return;
          if (button.dataset.step === '1') this.input.stepUp(); else this.input.stepDown();
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }, { signal: this.controller.signal });
        this.input.addEventListener('change', sync, { signal: this.controller.signal });
        sync();
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
